import styled from 'styled-components';

interface IconWrapperStyled {
    disabled?: boolean;
}

export const IconWrapper = styled.div<IconWrapperStyled>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #CACACA;
  opacity: ${props => props.disabled ? 0.5 : 1};
  padding: 7px;
`;

export const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 10%;
  background: #fff;
`;
